import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { IScheduleDocUploadStatusModel } from 'src/app/ViewModel/ScheduleDocumentModel';

@Component({
  selector: 'app-schedule-excel-upload',
  templateUrl: './schedule-excel-upload.component.html',
  styleUrls: ['./schedule-excel-upload.component.css']
})
export class ScheduleExcelUploadComponent implements OnInit {
  statusList: IScheduleDocUploadStatusModel[] = [];
  total!: number;
  success!: number;
  failure!: number;
  enableFullscreen = false;
  enableFilter = false;
  constructor(public dialogRef: MatDialogRef<ScheduleExcelUploadComponent>, private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public _data: IScheduleDocUploadStatusModel[]) {
  }

  ngOnInit() {
    this.statusList = this._data;
    this.total = this.statusList.length;
    this.success = this.statusList.filter(x => x.status).length;
    this.failure = this.total - this.success;
  }

  getStatus(item: IScheduleDocUploadStatusModel): string {
    return item.status ? item.is_Created ? "Created Successfully" : "Updated Successfully" : "Fail";
  }

  closeDialog() {
    this.dialogRef.close();
  }

  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }


  toggleFullscreen() {
    this.enableFullscreen = !this.enableFullscreen;
  }

  public showOnlyFailureDetails(dataItem: IScheduleDocUploadStatusModel, index: number): boolean {
    return dataItem.status == false;
  }

}
